import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { User } from '../_models/user';
import { AuthenticationService } from '../authentication.service';
import { OrganisationService } from "../create-organisation/organisation.service";
import AOS from 'aos';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, Validators } from '@angular/forms';
import { SubscriptionService } from "../subscription/subscription.service";
import { ReCaptchaV3Service } from 'ngx-captcha';
import { AlertService } from "../components/alert/alert.service";

@Component({
  selector: 'app-celebrate-subscriber',
  templateUrl: './celebrate-subscriber.component.html',
  styleUrls: ['./celebrate-subscriber.component.css']
})
export class CelebrateSubscriberComponent implements OnInit {

  title = 'Digital assets management | organise your creativity | Sign up for free storage ';

  constructor(
    private router: Router,
    private titleService: Title,
    private metaTagService: Meta,
    private authenticationService: AuthenticationService,
    private organisationService: OrganisationService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private subscriptionService: SubscriptionService,
    private reCaptchaV3Service: ReCaptchaV3Service,
    private cdr: ChangeDetectorRef,
    private alert: AlertService,
  ) { }

  currentUser: User;
  mobileView: boolean = false;
  mobileViewSection: boolean = false;

  showGoToApp: boolean = false;
  showTime: boolean = false;
  showFinalTime: boolean = false;
  showSubmitBtn: boolean = false;
  shownTime: string;
  showDate: boolean = true;
  shownDate: string;
  shownMonth: string;
  shownDay: string;
  timeSelected: boolean = false;
  dateSelected: boolean = false;
  availableTimeSlots = [];
  availableSlots = [];
  selectedTime: any;
  selectedDate: any;
  thankYouText: string = "Thank you, select date for a quick call.";
  userName: string;
  userEmail: string;
  companyName: string;
  date: string;
  time: string;

  isShowError: boolean = false;
  isDateSelected: boolean = false;
  isTimeSelected: boolean = false;
  showSelectionMessage: boolean = false;
  showLeaveLoader: boolean = false;
  showSelectedMsg: string;
  sendingProcessStyle = "none";

  isMobile: any;
  maintenanceProcessStyle = "none";
  public siteKey?: string = '6Lf59_gUAAAAAEJNHrHp1Vdd1LaG1epuOF62yj80';

  @ViewChild('letsTalk') letsTalk;
  @ViewChild('selectDate') selectDate;
  @ViewChild('showloader') showloader;
  @ViewChild('thankyou') thankyou;

  letsTalkForm = this.fb.group({
    name: ['', Validators.required],
    lname: ['', Validators.required],
    message: ['Main home page(inside)', Validators.required],
    email: ['', [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"), Validators.required]],
    company: ['', Validators.required],
  });

  submitted: Boolean = false;
  reload: Boolean = true;
  aFormGroup: any;

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.metaTagService.addTags([
      { name: 'description', content: 'Crafttor digital assets management is a trendy and awesome file manager. You can store, organise and tag your assets in an attractive manner. Hurry up, sign up today!'},
      { name: 'keywords', content: 'digital assets management, dam, DAM, free assets upload, digital storage, cloud storage, assets storage, assets tagging, organise digital assets, images upload' },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'Crafttor' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { charset: 'UTF-8' }
    ]);
    AOS.init();

    if (this.isMobile) {
      this.mobileViewSection = true;
      this.mobileView = true;
    }else{
      this.mobileViewSection = false;
      this.mobileView = false;
    }

    this.authenticationService.currentUser.subscribe(x => { this.currentUser = x });
  }

  listWorkspace(){
    if (this.currentUser) {
      this.organisationService.getWorkspaceList().subscribe((data: any) => {
        if(data.length > 0){
          localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: data[0].id,
            workspaceName: data[0].title }));
          this.router.navigate(['/dam']);
        }else{
          this.router.navigate(['/create-workspace']);
        }
      },
      (error) => {
        if(error.status == 500){
          // this.router.navigate(['/maintenance']);
          this.maintenanceProcessStyle = "block";
        } else {

        }
    });
    }else{
        this.router.navigate(['/login']);
    }
  }

  openMarketplace() {
    window.open("https://crafttor.com/marketplace", "_blank");
  }

  openLetsTalkDialog(modal){
      this.letsTalk = this.modalService.open(modal, { centered: true, windowClass: 'sign-up ' });
  }

  openThankskDialog(modal){
      this.thankyou = this.modalService.open(modal, { centered: true, windowClass: 'thanks-popup ' });
  }

  openSelectTimeDialog(modal){
      this.selectDate = this.modalService.open(modal, { centered: true, windowClass: 'select-time-popup ' });
  }

  public submitContactUs(modal) {
    this.submitted = true;
    if (this.letsTalkForm.valid) {
      this.showLeaveLoader = true;
      this.reCaptchaV3Service.execute(this.siteKey, 'contact_us', (token) => {
        this.letsTalkForm.value['recaptcha'] = token;
        this.cdr.detectChanges();
        this.userName = this.letsTalkForm.value['name'] +" "+this.letsTalkForm.value['lname'];
        this.userEmail = this.letsTalkForm.value['email'];
        this.companyName = this.letsTalkForm.value['company'] +" : " +this.letsTalkForm.value['message'];
        this.date = this.letsTalkForm.value['date'];
        this.time = this.letsTalkForm.value['time_start'];
        this.letsTalkForm.reset()
        this.letsTalk.close();
        this.showLeaveLoader = false;
        this.getDateListApi();
        this.selectDate = this.modalService.open(modal, { centered: true, windowClass: 'select-time-popup ' });
      });
    }
  }

  getDateListApi() {
    this.subscriptionService.getDateCall().subscribe((data: any) => {
      this.availableSlots = data;
      this.getTimeListApi(data[0].date);
    });
  }

  getTimeListApi(date: any) {
    this.subscriptionService.getTimeCall(date).subscribe((data: any) => {
      this.availableTimeSlots = data;
    });
  }

  contactSalesCall(modal) {
    if(this.isDateSelected == true && this.isTimeSelected == true) {
      this.sendingProcessStyle = "block";
       this.subscriptionService.contactSalesCallApi(this.userName, this.userEmail, this.companyName,
         this.selectedDate, this.selectedTime).subscribe((data) => {
         this.showLeaveLoader = false;
         this.submitted = false;
         this.sendingProcessStyle = "none";
         this.openThankskDialog(modal);
       },(error: any) => {
         if(error.status == 400){
           this.showLeaveLoader = false;
           this.submitted = false;
           this.sendingProcessStyle = "none";
           this.alert.error(error.error.message);
         } else {
           this.showLeaveLoader = false;
           this.submitted = false;
           this.sendingProcessStyle = "none";
           this.alert.error(error.error.message);
         }
      });
    } else if(this.isDateSelected == false) {
      this.showLeaveLoader = false;
      this.showSelectionMessage = true;
      this.showSelectedMsg = "Select Date";
    } else if(this.isTimeSelected == false) {
      this.showLeaveLoader = false;
      this.showSelectionMessage = true;
      this.showSelectedMsg = "Select Time";
    }
  }
}
